"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferContractDuration = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const OfferDetails_model_1 = require("@src/components/modules/global/OfferDetail/OfferDetails.model");
const OfferDetails_style_1 = require("@src/components/modules/global/OfferDetail/OfferDetails.style");
const getOfferContractDuration = ({ isIndefinite, durationMin, durationMax, durationType, intl, }) => {
    if (typeof isIndefinite !== 'boolean' && typeof isIndefinite !== 'number') {
        return null;
    }
    const showExactDuration = durationMin && durationMax && durationMin === durationMax;
    const showMinDuration = durationMin && !durationMax;
    if (isIndefinite) {
        return ((0, jsx_runtime_1.jsxs)(OfferDetails_style_1.TextSection, { children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.contract_duration" }) }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.indefinite_contract_duration" })] }));
    }
    if (showExactDuration) {
        return ((0, jsx_runtime_1.jsxs)(OfferDetails_style_1.TextSection, { children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.contract_duration" }) }), ' ', durationMin, " ", (0, OfferDetails_model_1.translateType)(durationMin, durationType, intl)] }));
    }
    if (showMinDuration) {
        return ((0, jsx_runtime_1.jsxs)(OfferDetails_style_1.TextSection, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.contract_duration_minimal", values: {
                        strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                    } }), durationMin, " ", (0, OfferDetails_model_1.translateType)(durationMin, durationType, intl)] }));
    }
    return ((0, jsx_runtime_1.jsxs)(OfferDetails_style_1.TextSection, { children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.contract_duration" }) }), ' ', durationMin, " - ", durationMax, " ", (0, OfferDetails_model_1.translateType)(durationMax, durationType, intl)] }));
};
exports.getOfferContractDuration = getOfferContractDuration;
